import { useMemo } from "react";
import { cancelDownload, downloadAll, offlineCount, removeAll, useOfflineJobs } from "@/lib/offlineQueue";
import { needsHomeScreen } from "@/lib/push";
import { sfx } from "@/lib/sfx";
import type { Track } from "@/types/types";

/** "Télécharger" for a whole list (playlist, liked, album, mix). */
export function DownloadButton({ id, label, tracks }: { id: string; label: string; tracks: Track[] }) {
  const { jobs, version } = useOfflineJobs();
  const job = jobs.find((j) => j.key === id);
  // re-count when any download progresses
  const saved = useMemo(() => offlineCount(tracks), [tracks, version]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!tracks.length || !("caches" in window)) return null;

  if (job) {
    const n = job.done + job.failed;
    return (
      <button className="btn dl-btn busy" title="Annuler le téléchargement"
              onClick={() => { sfx.tap(); cancelDownload(id); }}>
        <span className="dl-ring" style={{ ["--p" as string]: `${Math.round((100 * n) / job.ids.length)}%` }} />
        {n}/{job.ids.length} · Annuler
      </button>
    );
  }
  if (saved === tracks.length) {
    return (
      <button className="btn dl-btn done" title="Disponible sans connexion — cliquer pour supprimer les fichiers"
              onClick={() => {
                if (!window.confirm(`Supprimer les ${saved} titres téléchargés de « ${label} » ?`)) return;
                sfx.tap();
                void removeAll(tracks);
              }}>
        ✓ Téléchargée
      </button>
    );
  }
  return (
    <button className="btn dl-btn"
            title={needsHomeScreen()
              ? "Sur iPhone la place est limitée (~50 Mo) : ajoute slowson à l'écran d'accueil pour en avoir plus"
              : "Écouter ces titres sans connexion"}
            onClick={() => { sfx.pop(); downloadAll(id, label, tracks); }}>
      ⬇ Télécharger{saved > 0 ? ` (${saved}/${tracks.length})` : ""}
    </button>
  );
}
